import { css } from '@Root/lib/lit-3form-block';

export const styles = [
  css`
    :host {
      /* Row spacing is carried by each row's own padding; zeroing the
         shared gap keeps the padding tracks exact too. */
      --block-row-gap: 0px;
      display: block;
      color: var(--block-text-color, #222);
    }

    /*
      Mobile: eyebrow, header, and description each get their own row in the
      6-column grid. Vertical spacing is set with padding on the items, so the
      grid's mobile row gap is dropped to keep the math readable.
    */
    .nancy-layout {
      grid-template-rows:
        var(--block-top-padding)
        minmax(0, auto)
        minmax(0, auto)
        minmax(0, auto)
        var(--block-bottom-padding)
        [last-line];
      max-width: 100%;
    }

    /* Eyebrow is a p, but pinned to Body Small so it stays 14px on desktop. */
    .eyebrow {
      grid-column: 2 / 8;
      grid-row: 2;
      padding-bottom: calc(40rem / var(--default-rem-px-count));
      font-size: var(--fs-body-small);
      line-height: var(--lh-body-small);
      letter-spacing: var(--ls-body-small);
      font-weight: var(--fw-regular);
    }

    .header {
      grid-column: 2 / 8;
      grid-row: 3;
      padding-bottom: calc(30rem / var(--default-rem-px-count));
    }

    .description {
      grid-column: 2 / 8;
      grid-row: 4;
    }

    @media (min-width: 600px) {
      /*
        Tablet: header and description share one row, split down the middle of
        the 12-column grid and aligned on a common baseline.
      */
      .nancy-layout {
        grid-template-rows:
          var(--block-top-padding)
          minmax(0, auto)
          minmax(0, auto)
          var(--block-bottom-padding)
          [last-line];
      }

      .eyebrow {
        grid-column: 2 / 14;
        padding-bottom: calc(60rem / var(--default-rem-px-count));
      }

      .header {
        grid-column: 2 / 8;
        grid-row: 3;
        align-self: baseline;
        padding-bottom: 0;
      }

      .description {
        grid-column: 8 / 14;
        grid-row: 3;
        align-self: baseline;
      }
    }

    @media (min-width: 1024px) {
      /*
        Desktop: header and description are four columns each with a single
        empty column between them, so the row ends at column 11 and leaves the
        right side of the grid open.
      */
      .eyebrow {
        grid-column: 2 / 6;
        padding-bottom: calc(180rem / var(--default-rem-px-count));
      }

      .header {
        grid-column: 2 / 6;
      }

      .description {
        grid-column: 7 / 11;
      }
    }
  `,
];
